import styled from '@emotion/styled';

import NotificationIcon from '../../../components/Icons/NotificationIcon';
import { InternalNavLink } from '../../../components/Link/Link';
import { useAppSelector } from '../../../redux/store';
import { NOTIFICATIONS } from '../../../routes/routeConstants';
import { capitalize, getInitials } from '../../../utils/utils';

const DashboardHeader = () => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <Container>
      <IconsContainer>
        <IconWrapper>
          <InternalNavLink to={`/${NOTIFICATIONS}`}>
            <NotificationIcon />
          </InternalNavLink>
        </IconWrapper>
        <NameIcon>
          <LetterIcon>
            {getInitials(authData?.user?.firstName, authData?.user?.lastName)}
          </LetterIcon>
          <InfoArea>
            <Name>
              {`${capitalize(authData?.user?.firstName ?? '') || '...'}`}{' '}
              {`${capitalize(authData?.user?.lastName ?? '') || '...'}`}
            </Name>
            <Role>{capitalize(authData?.user?.role ?? '') || '...'}</Role>
          </InfoArea>
        </NameIcon>
      </IconsContainer>
    </Container>
  );
};

export default DashboardHeader;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 82px;
  padding-right: 36px;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid
    ${({ theme }) => theme.palette.layoutBorderBottomColor};
`;

const IconsContainer = styled.section`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.palette.lightGrayText};

  & > * > svg {
    color: ${({ theme }) => theme.palette.lightGrayText};
  }
  &:hover {
    cursor: pointer;

    & > * > svg {
      color: #504b49;
    }
  }

  &.no-pointer {
    cursor: default;
  }
`;

const NameIcon = styled.div`
  display: flex;
  width: fit-content;
  border: 1px solid ${({ theme }) => theme.palette.lightBorder};
  padding: 12px 24px;
  border-radius: 49px;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};
  cursor: default;
`;

const LetterIcon = styled.div`
  border-radius: 100%;
  background-color: ${({ theme }) => theme.palette.blueColor};
  color: white;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;

  width: fit-content;
  overflow: auto;
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const Role = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
